import React from 'react';

const ResendIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg" width="490" height="490" viewBox="0 0 24 24">
    <path d="M12 .775C5.813.775.775 5.813.775 12c0 6.187 5.038 11.225 11.225 11.225 6.187 0 11.225-5.038 11.225-11.225v-.175l-1.448-.05-.05.225c0 5.363-4.364 9.727-9.727 9.727S2.273 17.363 2.273 12 6.637 2.273 12 2.273l.331.005c2.528.084 4.88 1.125 6.644 2.945l1.834 1.922-3.222-.084-.05 1.447 5.638.05.05-5.638-1.448-.05-.05 3.195-1.674-1.881C17.92 1.986 15.06.775 12 .775z" transform="translate(-1182 -1001) translate(135 365) translate(20 377) translate(10 240) translate(1017 19)"/>
  </svg>
);

export default ResendIcon;
